export const SETTINGS_QUERY_KEYS = {
  apiKeys: ['settings', 'apiKeys'] as const,
  apiKeyList: (params: {
    readonly page: number
    readonly size: number
    readonly status?: string
    readonly environment?: readonly string[]
    readonly sort?: string
  }) => [...SETTINGS_QUERY_KEYS.apiKeys, 'list', params] as const,
  hosts: ['settings', 'hosts'] as const,
  hostList: (params: { readonly page: number; readonly size: number; readonly sort?: string }) =>
    [...SETTINGS_QUERY_KEYS.hosts, 'list', params] as const,
} as const
